import styled from 'styled-components';

export const StyledLogo = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  text-decoration: none;
`;

export const LogoText = styled.span`
  display: flex;
  height: 44px;
  margin-left: 24px;
  font-weight: 700;
  font-size: 28px;
  line-height: 42px;
  color: #333333;
`;
